import { useMemo, useState } from 'react';

interface Props {
  defaultValue?: string;
  value?: string;
  onChangeCallback?: (value: string, clean?: string) => void;
  isDisableClean?: boolean;
  isCleanValue?: boolean;
}
export const getClean = (value: string) => value?.length ? value.replace(',', '.').replace(/[^0-9.]/g, '') : value;

const useMaskedInput = ({ defaultValue = '', value, onChangeCallback, isDisableClean, isCleanValue }: Props) => {
  const [stateValue, setStateValue] = useState<string>(defaultValue);

  const clean = useMemo(() => {
    const currentValue = value ?? stateValue;

    if (!isDisableClean) {
      return getClean(currentValue);
    }

    return currentValue;
  }, [value, stateValue, isDisableClean]);

  const onChange = (value: any) => {
    if (onChangeCallback) {
      const clean = getClean(value);

      onChangeCallback(isCleanValue ? clean : value, !isCleanValue ? clean: undefined);
    } else {
      setStateValue(value);
    }
  };

  return {
    value: value ?? stateValue,
    clean,
    setValue: onChange,
  };
};

export default useMaskedInput;
